// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40')
];

export const server_loads = [];

export const dictionary = {
		"/": [10],
		"/app": [11,[2]],
		"/app/admin": [12,[2,3]],
		"/app/admin/enrollments": [13,[2,3]],
		"/app/admin/manage": [14,[2,3]],
		"/app/admin/settings": [15,[2,3]],
		"/app/admin/soap": [16,[2,3]],
		"/app/admin/test": [17,[2,3]],
		"/app/data-exchange": [18,[2,4]],
		"/app/data-exchange/errors": [19,[2,4]],
		"/app/data-exchange/messages": [20,[2,4]],
		"/app/facilities": [21,[2,5]],
		"/app/facilities/new": [22,[2,5]],
		"/app/match-review": [23,[2,6]],
		"/app/match-review/new": [25,[2,6]],
		"/app/match-review/[id]": [24,[2,6]],
		"/app/messages": [26,[2]],
		"/app/organizations": [27,[2]],
		"/app/organizations/new": [28,[2]],
		"/app/organizations/users": [29,[2]],
		"/app/patients": [30,[2]],
		"/app/patients/new": [31,[2]],
		"/app/patients/search": [32,[2]],
		"/enroll": [33,[7]],
		"/enroll/access": [37,[7]],
		"/enroll/(section)/data-exchange": [34,[7,8]],
		"/enroll/(section)/iis-access": [35,[7,8]],
		"/enroll/(section)/vfc-enrollment": [36,[7,8]],
		"/invitation/accept": [38],
		"/signin": [39,[9]],
		"/signin/verify": [40,[9]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);